import { isComponentFor } from "Shared/resolve-component";
export const isSearchPage = (currentPage) => {
    return (isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Search.Pages.Search.SearchPage") || isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Search.Pages.Search.SearchPageViewModel"));
};
export default (state) => {
    return componentIsSearch(state.currentPage.componentName);
};
export function componentIsSearch(componentName) {
    return (isComponentFor(componentName, "Avensia.Shop.Features.Search.Pages.Search.SearchPage") || isComponentFor(componentName, "Avensia.Shop.Features.Search.Pages.Search.SearchPageViewModel"));
}
